<template>
    <div class="modal fade" id="div-confirm-delete-passkey" tabindex="-1" aria-labelledby="informLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-center w-100 pl-4 pr-4">このパスキーを削除しますか?</h4>
                    <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-0">
                    <div class="row mb-2 ml-0 mr-0 passkey-item align-items-center p-2 rounded">
                        <div class="col-12 col-md-12 pl-1 pr-1">
                            <p class="mb-2 fs-13px text-center">{{this.params?.providerName || ''}}</p>
                            <p class="mb-2 text-left">作成日時 : {{this.params?.registrationDate || ''}}</p>
                            <p class="mb-2 text-left">最終使用日時 : {{this.params?.lastUsedDate || ''}}</p>
                        </div>
                    </div>
                    <b class="text-danger text-left fs-14px">
                        削除すると、このパスキーはログインに使用できなくなります。
                    </b>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-12 col-sm-6 col-lg-6 mb-2">
                            <button class="btn btn-sm btn-primary w-100" @click.prevent="deletePasskey()">
                                OK
                            </button>
                        </div>
                        <div class="col-12 col-sm-6">
                            <button class="btn btn-sm btn-default w-100" @click="closeModal()">
                                キャンセル
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import ServiceUtils from '@/common/utils/ServiceUtils';
    import IConstants from "@/common/constants/IConstants";

    export default {
        name: "ConfirmDeletePasskey",
        mixins: [],
        data() {
            return {
                params: {
                    fidoPasskeyId: null,
                    customerPasskeyId: null,
                    providerName: null,
                    registrationDate: null,
                    lastUsedDate: null
                }
            }
        },
        mounted() {
            this.onOpenEvent()
        },
        methods: {
            onOpenEvent() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_CONFIRM_DELETE_PASSKEY, (params) => {
                    $('#div-confirm-delete-passkey').modal({backdrop: 'static', keyboard: false});
                    this.params = params;
                    $("#div-confirm-delete-passkey").modal("show");
                });
            },
            deletePasskey() {
                this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .deletePasskey(this.params.fidoPasskeyId)
                    .then(async (res) => {
                        if (res.errorMessage) {
                            await this.closeModal();
                            return this.$modal.showProfileMessage({
                                message: {
                                    errorMessage: 'MSG_TRS_NAF_0221',
                                },
                                callBackFunc: () => {
                                    $("html, body").animate({scrollTop: 0}, "slow");
                                }
                            })
                        }
                        await this.closeModal();
                        this.$modal.showDeletePasskeyResult({result: true})
                    })
            },
            async closeModal() {
                await ServiceUtils.waitModalFullyHidden($("#div-confirm-delete-passkey"));
            },
        },
        validations() {
            return {}
        },
    }
</script>

<style scoped>
    .modal-close-btn {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }

    .passkey-item {
        background-color: rgba(253, 251, 243, 0.9);
        border: 1px solid rgba(243, 233, 199, 0.9);
        color: #9a7a3a;
    }
</style>
